import React from 'react';
import PropTypes from 'prop-types';
import DefaultCarousel from './DefaultCarousel';
import SmoothScrollCarousel from './SmoothScrollCarousel';

const CarouselWrapper = ({ enableSmoothScroll, ...props }) => {
  if (enableSmoothScroll) return <SmoothScrollCarousel {...props} />;
  return <DefaultCarousel {...props} />;
};

CarouselWrapper.propTypes = {
  enableSmoothScroll: PropTypes.bool
};

CarouselWrapper.defaultProps = {
  enableSmoothScroll: false
};

export default CarouselWrapper;
